




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import More from 'highcharts/highcharts-more';
import Highcharts from 'highcharts';
import { colors } from '@/config';
import vue from 'vue';

More(Highcharts);

@Component({components: {Chart}})
export default class ProfitLoss extends Vue {
  @Prop() readonly balance!: any;
  @Prop() dark!: boolean;

  chartOptions: any = {
    chart: {
      type: 'waterfall',
      backgroundColor: 'transparent',
    },

    credits: {
      enabled: false,
    },

    title: {
      text: '',
    },

    xAxis: {
      type: 'category',
      labels: {
        autoRotation: [0],
        staggerLines: 1,
        padding: 10,
        style: {
          fontSize: '1rem',
          textOverflow: 'none',
          whiteSpace: 'normal',
          color: this.dark ? colors.Light : colors.Black,
        },
      },
    },

    yAxis: {
      title: {
        text: '',
      },
      labels: {
        style: {
          fontSize: this.dark ? '1.25rem' : '1rem',
          color: this.dark ? colors.Light : colors.Black,
        },
        formatter() { return (vue as any).options.filters.KR((this as any).value); },
      },
      tickPixelInterval: this.dark ? 250 : 150,
      gridLineColor: this.dark ? colors.Black : colors.LightGrey,
      plotLines: [{
        color: colors.Black,
        width: this.dark ? 3 : 2,
        value: 0,
        zIndex: 20,
      }],
    },

    legend: {
      enabled: false,
    },

    tooltip: {
      headerFormat: '',
      pointFormat: '<span>{point.subname}: <b>{point.y:,.0f} tkr</b></span>',
      style: {
        fontSize: '1.25rem',
        color: this.dark ? colors.Light : colors.Black,
      },
      backgroundColor: this.dark ? colors.Dark : colors.Light,
    },

    series: [],
  };

  mounted() {
    if (this.balance) {
      this.chartOptions.series = this.getSeries();
    }
  }

  @Watch('balance', { immediate: true, deep: true })
  balanceChanged() {
    if (this.balance) {
      this.chartOptions.series = this.getSeries();
    }
  }

  getSeries() {
    return [{
      upColor: this.dark ? colors.Secondary : colors.Primary,
      color: colors.Tertiary,
      lineColor: this.dark ? colors.Black : colors.DarkGrey,
      borderColor: this.dark ? colors.Black : colors.DarkGrey,
      data: [
        {
          name: Vue.prototype.$t('Tecknat, men ej inbetalt kapital'),
          subname: Vue.prototype.$t('Tecknat, men ej inbetalt kapital'),
          y: this.balance.A,
        }, {
          name: Vue.prototype.$t('Anläggnings-tillgångar'),
          subname: Vue.prototype.$t('Immateriella'),
          y: this.balance.B,
        }, {
          name: Vue.prototype.$t('Anläggnings-tillgångar'),
          subname: Vue.prototype.$t('Materiella'),
          y: this.balance.C,
        }, {
          name: Vue.prototype.$t('Anläggnings-tillgångar'),
          subname: Vue.prototype.$t('Finansiella'),
          y: this.balance.D,
        }, {
          name: Vue.prototype.$t('Varulager'),
          subname: Vue.prototype.$t('Varulager'),
          y: this.balance.F,
        }, {
          name: Vue.prototype.$t('Övriga omsättnings-tillgångar'),
          subname: Vue.prototype.$t('Kundfordringar'),
          y: this.balance.G,
        }, {
          name: Vue.prototype.$t('Övriga omsättnings-tillgångar'),
          subname: Vue.prototype.$t('Övriga kortfristiga fordringar'),
          y: this.balance.H,
        }, {
          name: Vue.prototype.$t('Övriga omsättnings-tillgångar'),
          subname: Vue.prototype.$t('Kortfristiga placeringar'),
          y: this.balance.I,
        }, {
          name: Vue.prototype.$t('Övriga omsättnings-tillgångar'),
          subname: Vue.prototype.$t('Kassa och bank'),
          y: this.balance.J,
        }, {
          name: Vue.prototype.$t('Balans-omslutning'),
          subname: Vue.prototype.$t('Balansomslutning'),
          isIntermediateSum: true,
          color: colors.DarkGrey,
        }, {
          name: Vue.prototype.$t('Kortfristiga skulder'),
          subname: Vue.prototype.$t('Kortfristiga skulder'),
          y: -this.balance.Q,
        }, {
          name: Vue.prototype.$t('Långfristiga skulder'),
          subname: Vue.prototype.$t('Långfristiga skulder'),
          y: -this.balance.P,
        }, {
          name: Vue.prototype.$t('Avsättningar'),
          subname: Vue.prototype.$t('Avsättningar'),
          y: -this.balance.O,
        }, {
          name: Vue.prototype.$t('Eget kapital'),
          subname: Vue.prototype.$t('Obeskattade reserver'),
          y: -this.balance.N,
          color: colors.LightGrey,
        }, {
          name: Vue.prototype.$t('Eget kapital'),
          subname: Vue.prototype.$t('Eget kapital'),
          isSum: true,
          color: colors.Green,
          negativeColor: colors.Red,
        },
      ].filter( (o, i) => o.y !== 0 || (i > 0  && i !== 12) ),

      pointPadding: 0,
    }];
  }
}
